<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:65%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["OTP"]["OTPCL"]}}</h4>

                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isAMV=false">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <table class="custom-table afb-blue p-4">
                                            <thead>
                                                <tr>
                                                    <th style="width: 100px; text-align: center">{{this.getLanguage["GL"]["ACT"]}}</th>
                                                    <th v-if="getUserInfo.AT==0" style="width: 20%">{{this.getLanguage['BAL']['CC']}}</th>
                                                    <th style="width: 20%">{{this.getLanguage['BAL']['C']}}</th>
                                                    <th>{{this.getLanguage['OTP']['C']}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(data,index) in OTPList" :key="index">
                                                    <td class="py-2" v-if="getUserInfo.AT==0">
                                                        <span id="actionBtnCol">
                                                            <div class="custom_tooltip">
                                                                <i class="cil-color-border sortlogo" @click="editOTPCost(data)"></i>
                                                                <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                                            </div>
                                                        </span>
                                                    </td>
                                                    <td class="py-2">{{ data.CN }} </td>
                                                    <td class="py-2">{{ data.CS }} </td>
                                                    <td class="py-2">{{ formatNumber(data.OTPC,4) }} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </CRow>
                                </div>                                
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['CMS']['BN']}}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['OTP']['CC']}}
                                                <i @click="setSortTable('CC')" :class="setSortLogo('CC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'DATE'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['OTP']['DATE']}}
                                                <i @click="setSortTable('LTS')" :class="setSortLogo('LTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'MN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['OTP']['MN']}}
                                                <i @click="setSortTable('MN')" :class="setSortLogo('MN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'REGS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['OTP']['REGS']}}
                                                <i @click="setSortTable('CR')" :class="setSortLogo('CR')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'OTPC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                #{{getLanguage['OTP']['OTP']}}
                                                <i @click="setSortTable('OTPC')" :class="setSortLogo('OTPC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ISOC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['CI']}}
                                                <i @click="setSortTable('OTPCS')" :class="setSortLogo('OTPCS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'COST'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['OTP']['COST']}}
                                                <i @click="setSortTable('OTPCost')" :class="setSortLogo('OTPCost')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'GT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MTA']['GT']}}
                                                <i @click="setSortTable('GT')" :class="setSortLogo('GT')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="bool_isOTP">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:35%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["OTP"]["EOTPC"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeOTP()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol md="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["BAL"]["CC"]}}:</label>
                                            <CInput size="sm" :value="obj_OTP.CN" disabled />
                                        </CCol>
                                        <CCol md="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["BAL"]["C"]}}:</label>
                                            <CInput size="sm" :value="obj_OTP.CS" disabled />
                                        </CCol>
                                        <CCol md="6">
                                            <label class="col-form-label-sm">{{this.getLanguage["OTP"]["C"]}}<span class="required" /> :</label>
                                            <CInput size="sm" v-model="obj_OTP.OTPC" />
                                            <span class="ErrMsg">{{ ValidationOTPErrMsg('OTPC','OTP','C') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveOTPCost()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ this.getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('OTPR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['OTPR']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="!hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :flat="true"
                                                  :limit="1"
                                                  :load-options="loadAgentOptions"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :options="ddAgentList"
                                                  :defaultExpandLevel="Infinity"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  :disable-branch-nodes="false"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  :limitText="count => `+${count}`"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol' v-if="hide">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :flat="true"
                                                  :limit="1"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :options="ddAgentList2"
                                                  :defaultExpandLevel="Infinity"
                                                  :auto-load-root-options="convertToBool(searchAgent2)"
                                                  :disable-branch-nodes="false"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  :limitText="count => `+${count}`"
                                                  v-model="searchAgent2" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BAL"]["CC"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddCountryList"
                                            :placeholder="this.utilGetDDLanguage('BAL.CC')"
                                            v-model="searchCountryCode" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="right"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton ref="search" v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['SMB']['OTPR']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset px-2" @click="ViewOTPCost"><span class="fa-solid fa-search"></span>{{this.getLanguage['OTP']['OTPCL']}}</CButton>
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                    </div>
                </header>
                <span class="text-danger">{{this.getLanguage["OTP"]["NOTE"]}}</span>
                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th :colspan="10" style="z-index:1 !important">{{this.getLanguage['WLRPT']['T']}}</th>
                            </tr>
                        <td colspan="100%" v-if=" arr_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-else class="reportTotal">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, arr_reportTotalList[0])">
                                <template v-if="header == 'NO'">
                                    <a href="#" @click="bool_showReportDetail=!bool_showReportDetail">{{getLanguage['WLRPT']['VA']}}</a>
                                </template>
                                <template v-else-if="header == 'BN'">
                                </template>
                                <template v-else-if="header == 'CC'">
                                </template>
                                <template v-else-if="header == 'DATE'">
                                </template>
                                <template v-else-if="header == 'MN'">
                                </template>
                                <template v-else-if="header == 'REGS'">
                                    {{formatNumber(arr_reportTotalList[0].CR,0)}}
                                    <span class="text-success">Yes</span> /
                                    {{ formatNumber(arr_reportTotalList[0].CUR,0) }}
                                    <span class="text-danger">No</span>
                                </template>
                                <template v-else-if="header == 'OTPC'">
                                    {{formatNumber(arr_reportTotalList[0].OTPC,0)}}
                                </template>
                                <template v-else-if="header == 'ISOC'">
                                    {{arr_reportTotalList[0].OTPCS}}
                                </template>
                                <template v-else-if="header == 'COST'">
                                </template>
                                <template v-else-if="header == 'GT'">
                                    {{formatNumber(arr_reportTotalList[0].GT,4)}}
                                </template>
                            </td>
                        </tr>
                        <draggable v-model="reportHeaders" tag="tr">
                            <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                <template v-if="header == 'NO'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['GL']['NO']}}
                                </template>
                                <template v-else-if="header == 'BN'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['CMS']['BN']}}
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'CC'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['OTP']['CC']}}
                                    <i @click="setSortTable('CC')" :class="setSortLogo('CC')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'DATE'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['OTP']['DATE']}}
                                    <i @click="setSortTable('LTS')" :class="setSortLogo('LTS')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'MN'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['OTP']['MN']}}
                                    <i @click="setSortTable('MN')" :class="setSortLogo('MN')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'REGS'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['OTP']['REGS']}}
                                    <i @click="setSortTable('CR')" :class="setSortLogo('CR')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'OTPC'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    #{{getLanguage['OTP']['OTP']}}
                                    <i @click="setSortTable('OTPC')" :class="setSortLogo('OTPC')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'ISOC'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['MEM']['CI']}}
                                    <i @click="setSortTable('OTPCS')" :class="setSortLogo('OTPCS')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'COST'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['OTP']['COST']}}
                                    <i @click="setSortTable('OTPCost')" :class="setSortLogo('OTPCost')" class="sortlogo"></i>
                                </template>
                                <template v-else-if="header == 'GT'">
                                    <i class="fa fa-times" @click="removeColumn(header)"></i>
                                    {{getLanguage['MTA']['GT']}}
                                    <i @click="setSortTable('GT')" :class="setSortLogo('GT')" class="sortlogo"></i>
                                </template>
                            </th>
                        </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['CMS']['BN']}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['OTP']['CC']}}
                                        <i @click="setSortTable('CC')" :class="setSortLogo('CC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'DATE'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['OTP']['DATE']}}
                                        <i @click="setSortTable('LTS')" :class="setSortLogo('LTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'MN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['OTP']['MN']}}
                                        <i @click="setSortTable('MN')" :class="setSortLogo('MN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'REGS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['OTP']['REGS']}}
                                        <i @click="setSortTable('CR')" :class="setSortLogo('CR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'OTPC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        #{{getLanguage['OTP']['OTP']}}
                                        <i @click="setSortTable('OTPC')" :class="setSortLogo('OTPC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CI']}}
                                        <i @click="setSortTable('OTPCS')" :class="setSortLogo('OTPCS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'COST'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['OTP']['COST']}}
                                        <i @click="setSortTable('OTPCost')" :class="setSortLogo('OTPCost')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'GT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MTA']['GT']}}
                                        <i @click="setSortTable('GT')" :class="setSortLogo('GT')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody v-if="bool_showReportDetail">
                        <td colspan="100%" v-if=" arr_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in sortedReportList">
                            <tr v-if="data.GN" @click="toggleDisplay(data.AGI+'#'+data.CC+'#'+data.OTPCost)" style="cursor:pointer;">
                                <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                    <template v-if="header == 'NO'">
                                        {{ data.RN }}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <span class="grid-line">{{ data.GN }} ({{ data.PC }})</span>
                                    </template>
                                    <template v-else-if="header == 'CC'">
                                        {{ data.CC }}
                                    </template>
                                    <template v-else-if="header == 'DATE'">
                                    </template>
                                    <template v-else-if="header == 'MN'">
                                    </template>
                                    <template v-else-if="header == 'REGS'">
                                        {{formatNumber(data.CR,0)}}
                                        <span class="text-success">Yes</span> /
                                        {{ formatNumber(data.CUR,0) }}
                                        <span class="text-danger">No</span>
                                    </template>
                                    <template v-else-if="header == 'OTPC'">
                                        {{formatNumber(data.OTPC,0)}}
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                        {{data.OTPCS}}
                                    </template>
                                    <template v-else-if="header == 'COST'">
                                        {{formatNumber(data.OTPCost,4)}}
                                    </template>
                                    <template v-else-if="header == 'GT'">
                                        {{formatNumber(data.GT,4)}}
                                    </template>
                                </td>
                            </tr>
                            <tr v-else-if="opened.includes(data.AGI+'#'+data.CC+'#'+data.OTPCost)">
                                <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                    <template v-if="header == 'NO'">
                                        {{ data.RN }}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                    </template>
                                    <template v-else-if="header == 'CC'">
                                    </template>
                                    <template v-else-if="header == 'DATE'">
                                        {{ formatDateTime(data.LTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                    </template>
                                    <template v-else-if="header == 'MN'">
                                        {{ data.MN }}
                                    </template>
                                    <template v-else-if="header == 'REGS'">
                                        <span class="text-success" v-if="data.CR > 0">Yes</span>
                                        <span class="text-danger" v-else>No</span>
                                    </template>
                                    <template v-else-if="header == 'OTPC'">
                                    </template>
                                    <template v-else-if="header == 'ISOC'">
                                    </template>
                                    <template v-else-if="header == 'COST'">
                                    </template>
                                    <template v-else-if="header == 'GT'">
                                    </template>
                                </td>
                            </tr>
                        </template>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue';
    import { required, decimal, minValue } from 'vuelidate/lib/validators';
    import { constAccessType, constRejectReasonD, loadingFullScreen } from '@/modules/Constant.js';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                bool_CVOTP: false, // Check Validation
                bool_isOTP: false, // Add Modal Visible
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_firstLogin: false,
                bool_showSearchBar: true,
                bool_showReportDetail: false,
                ddAgentList: null,
                ddAgentList2: null,
                // search fields
                searchAgi: '',
                searchAgi2: '',
                searchAgent: null,
                searchAgent2: [],
                searchAgent2Main: null,
                selectedAgent: null,
                searchAgT: 0,
                pre_searchAgT: 0,
                searchCountryCode:null,
                searchCreatedTS: { startDate: this.getTodayDate(), endDate: this.getMonthEndDate() },
                arr_reportList: [],
                arr_reportTotalList: [],
                ddCountryList: [],
                constAccessType: constAccessType,
                opened: [],
                str_tableSortBy: "LTS", //(sort the table col name)
                defaultDescendingColumns: ['LTS'],
                bool_isSort: true, // Table Ascending Descending
                defaultReportHeaders: ['NO', 'BN', 'CC', 'DATE', 'MN','REGS','OTPC', 'ISOC', 'COST', 'GT'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                OTPList: [],
                obj_OTP: {
                    OTPC: null
                }
            }
        },
        validations: {
            obj_OTP: {
                OTPC: { required, decimal, minValueValue: minValue(0) }
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            
            getAgentGroup(loadReport = false) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.ddAgentList = that.deepClone(d.dropdownlist);
                            that.ddAgentList2 = that.deepClone(d.dropdownlist);

                            if (that.ddAgentList.length > 0) {
                                that.disableAgentGroupLevel();
                            }
                            if (that.ddAgentList2.length > 0) {
                                that.selectAgentGroup2Level();
                            }
                            if (loadReport) {
                                that.getReportList();
                            }
                        }
                    });
            },
            disableAgentGroupLevel() {
                var that = this;
                if (that.selectedAgent != null && that.selectedAgent.length > 0) {
                    var selectedAgent = that.selectedAgent[0].split("-")[0];
                    for (var j = 0; j < that.ddAgentList.length; j++) {
                        var itemLevel = that.ddAgentList[j].id.split("-")[0];

                        if (selectedAgent != itemLevel && itemLevel == "0") {
                            that.ddAgentList[j].isDisabled = true;
                        }

                        if (that.ddAgentList[j].children && that.ddAgentList[j].children.length > 0) {
                            for (var k = 0; k < that.ddAgentList[j].children.length; k++) {
                                var itemLevel1 = that.ddAgentList[j].children[k].id.split("-")[0];

                                if (selectedAgent != itemLevel1 && itemLevel1 == "1") {
                                    that.ddAgentList[j].children[k].isDisabled = true;
                                }

                                if (that.ddAgentList[j].children[k].children && that.ddAgentList[j].children[k].children.length > 0) {
                                    for (var l = 0; l < that.ddAgentList[j].children[k].children.length; l++) {
                                        var itemLevel2 = that.ddAgentList[j].children[k].children[l].id.split("-")[0];

                                        if (selectedAgent != itemLevel2 && itemLevel2 == "2") {
                                            that.ddAgentList[j].children[k].children[l].isDisabled = true;
                                        }

                                        if (that.ddAgentList[j].children[k].children[l].children && that.ddAgentList[j].children[k].children[l].children.length > 0) {
                                            for (var m = 0; m < that.ddAgentList[j].children[k].children[l].children.length; m++) {
                                                var itemLevel3 = that.ddAgentList[j].children[k].children[l].children[m].id.split("-")[0];

                                                if (selectedAgent != itemLevel3 && itemLevel3 == "3") {
                                                    that.ddAgentList[j].children[k].children[l].children[m].isDisabled = true;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                } else {
                    that.searchAgent2Main = that.selectedAgent;
                    that.searchAgent2 = [];
                    that.searchAgT = 0;
                }
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                            that.ddAgentList2 = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                            that.ddAgentList2 = null;
                            that.searchAgT = 0;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                if (value && value.length > 0) {
                    var agentList = value[0].split("-");
                    this.searchAgT = agentList[agentList.length - 2];
                }

                var temp = "";
                for (var x = 0; x < value.length; x++) {
                    if (x != 0) {
                        temp += ",";
                    }
                    var split = value[x].split("-");

                    if (split.length == 2) {
                        temp += split[1];
                    }
                    else {
                        temp += split[0];
                    }
                }
                this.searchAgi = temp;

                this.selectedAgent = value;
                this.searchAgent2Main = value;
                this.getAgentGroup();
            },
            selectAgentGroup2Level() {
                var that = this;
                that.searchAgent2 = [];

                for (var h = 0; h < that.searchAgent2Main.length; h++) {
                    that.searchAgent2.push(that.searchAgent2Main[h]);
                    var currentAgent = that.searchAgent2Main[h];
                    var selectedAgentLevel = that.searchAgent2Main[h].split("-")[0];
                    for (var j = 0; j < that.ddAgentList2.length; j++) {
                        var itemLevel = that.ddAgentList2[j].id.split("-")[0];

                        if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel)) {
                            this.searchAgent2.push(that.ddAgentList2[j].id);
                        }

                        if (that.ddAgentList2[j].children && that.ddAgentList2[j].children.length > 0) {
                            for (var k = 0; k < that.ddAgentList2[j].children.length; k++) {
                                var itemLevel1 = that.ddAgentList2[j].children[k].id.split("-")[0];

                                if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel1)) {
                                    if (currentAgent == that.ddAgentList2[j].id) {
                                        this.searchAgent2.push(that.ddAgentList2[j].children[k].id);
                                    }
                                }

                                if (that.ddAgentList2[j].children[k].children && that.ddAgentList2[j].children[k].children.length > 0) {
                                    for (var l = 0; l < that.ddAgentList2[j].children[k].children.length; l++) {
                                        var itemLevel2 = that.ddAgentList2[j].children[k].children[l].id.split("-")[0];

                                        if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel2)) {
                                            if (currentAgent == that.ddAgentList2[j].id ||
                                                currentAgent == that.ddAgentList2[j].children[k].id) {
                                                this.searchAgent2.push(that.ddAgentList2[j].children[k].children[l].id);
                                            }
                                        }

                                        if (that.ddAgentList2[j].children[k].children[l].children && that.ddAgentList2[j].children[k].children[l].children.length > 0) {
                                            for (var m = 0; m < that.ddAgentList2[j].children[k].children[l].children.length; m++) {
                                                var itemLevel3 = that.ddAgentList2[j].children[k].children[l].children[m].id.split("-")[0];

                                                if (parseFloat(selectedAgentLevel) < parseFloat(itemLevel3)) {
                                                    if (currentAgent == that.ddAgentList2[j].id ||
                                                        currentAgent == that.ddAgentList2[j].children[k].id ||
                                                        currentAgent == that.ddAgentList2[j].children[k].children[l].id) {
                                                        this.searchAgent2.push(that.ddAgentList2[j].children[k].children[l].children[m].id);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                var temp2 = "";
                for (var x = 0; x < this.searchAgent2.length; x++) {
                    if (x != 0) {
                        temp2 += ",";
                    }
                    var split = this.searchAgent2[x].split("-");

                    if (split.length == 2) {
                        temp2 += split[1];
                    }
                    else {
                        temp2 += split[0];
                    }
                }
                this.searchAgi2 = temp2;
            },
      
            newSearch() {
                this.$refs.search.focus();
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getReportList();
            },
            getReportList() {
                this.bool_fullLoading = true;
                var that = this;
                var param = {
                    "s": that.str_tableSortBy,
                    "d": that.bool_isSort,
                    "f": {
                        "AGI_csv": (this.searchAgi2 != 0) ? this.searchAgi2 : "",
                        "CC": this.searchCountryCode,
                        "STS_from": (this.searchCreatedTS.startDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.startDate) : "",
                        "STS_to": (this.searchCreatedTS.endDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.endDate) : "",
                    }
                }

                this.postDataApi(`/api/reports/otpr`, param,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arr_reportTotalList = d.R1;
                            that.arr_reportList = d.R2;
                            that.resizeTableHead();
                        }
                    });
            },
            saveToExcel() {

                this.bool_fullLoading = false;
                var that = this;
                //var agentGId = null;

                var param = {
                    "s": that.str_tableSortBy,
                    "d": that.bool_isSort,
                    "f": {
                        "AGI_csv": (this.searchAgi2 != 0) ? this.searchAgi2 : "",
                        "CC": this.searchCountryCode,
                        "STS_from": (this.searchCreatedTS.startDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.startDate) : "",
                        "STS_to": (this.searchCreatedTS.endDate != '') ? this.parseDateToJsonString(this.searchCreatedTS.endDate) : "",
                    }
                }

                var form = document.createElement("form");
                form.method = "POST";
                form.action = "/api/reports/eotpr";
                form.target = "_blank";

                for (var key in param) {
                    if (param.hasOwnProperty(key) && key == "f") {
                        for (var fkey in param['f']) {
                            var hiddenField = document.createElement('input');
                            hiddenField.type = "hidden";
                            hiddenField.name = key + '[' + fkey + ']'
                            hiddenField.value = param['f'][fkey];
                            form.appendChild(hiddenField);
                        }
                    }
                    else if (param.hasOwnProperty(key)) {
                        var hiddenField = document.createElement('input');
                        hiddenField.type = "hidden";
                        hiddenField.name = key;
                        hiddenField.value = param[key];
                        form.appendChild(hiddenField);
                    }
                }

                document.body.appendChild(form);
                form.submit();
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getTodayDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EOTPR', 'R', type);
            },

            getCountryList() {
                var that = this;
                this.getDataApi(`/api/dd/country`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCountryList = d.dropdownlist;                         
                        }
                        else {
                            that.ddCountryList = null;
                        }
                    });
            },
            closeOTP() {
                this.bool_CVOTP = false;
                this.bool_isOTP = !this.bool_isOTP;
            },
            ViewOTPCost() {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/cur/otpl`,
                    function (d, s) {
                        that.OTPList = d;
                        that.bool_fullLoading = false;
                        that.bool_isAMV = true;
                    });
            },
            editOTPCost(data) {
                this.obj_OTP = Object.assign({}, data);
                this.bool_CVOTP = false;
                this.bool_isOTP = true;
            },
            saveOTPCost() {                
                this.bool_CVOTP = true;
                this.$v.obj_OTP.$touch();
                if (!this.$v.obj_OTP.$error) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;
                    this.postDataApi(`/api/cur/sotpc`, this.obj_OTP,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isOTP = false;
                                that.ViewOTPCost();
                            }
                        });
                }
            },
            toggleDisplay(key) {
                const index = this.opened.indexOf(key);
                if (index > -1) {
                    this.opened.splice(index, 1)
                } else {
                    this.opened.push(key)
                }
                this.resizeTableHead();
            },
            setSortTable(SV) {//SV = Sort Value
                if (this.str_tableSortBy !== SV) {
                    this.str_tableSortBy = SV;
                    if (this.defaultDescendingColumns.includes(SV)) {
                        this.bool_isSort = true;
                    } else {
                        this.bool_isSort = false;
                    }
                } else {
                    this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                }

            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                // 保存当前滚动位置
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");
                const currentScrollLeft = header.scrollLeft;

                // 原来的逻辑（可以选择删除直接重置滚动位置的那行）
                // $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(3) th');
                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });

                // 还原滚动位置
                header.scrollLeft = currentScrollLeft;
                body.scrollLeft = currentScrollLeft;
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },

            renderClassName(header, data) {
                if (header == 'REGS' || header == 'ISOC' || header == 'CC') {
                    return "tableCtnCenter";
                } else if (header == 'COST' || header == 'GT' || header == 'OTPC') {
                    return "tableCtnRight";
                }
            },
            resetColumn(headerName) {
                var that = this;

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            ValidationOTPErrMsg(value, key1 = "", key2 = "") {
                if (this.bool_CVOTP) {
                    var validateObj = this.$v.obj_OTP[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[key1][key2]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage[key1][key2]);
                    }
                    else if (validateObj.minValueValue != undefined && !validateObj.minValueValue) {
                        return String.format(this.utilGetErrorLanguage('4442'), this.getLanguage[key1][key2]);
                    }
                }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
            sortedReportList() {
                const list = Array.isArray(this.arr_reportList) ? this.arr_reportList : [];
                const sortField = this.str_tableSortBy;
                let tempCatList = [];
                for (var i = 0; i < list.length; i++) {
                    if (list[i]['GN']) {
                        tempCatList.push(list[i]);
                    }
                }

                tempCatList = tempCatList.sort((a, b) => {
                    let valA, valB;
                    valA = a[sortField];
                    valB = b[sortField];
                    if (sortField == 'LTS') {
                        valA = Date.parse(valA);
                        valB = Date.parse(valB);
                    }
                    else if (!isNaN(parseFloat(valA)) && !isNaN(parseFloat(valB))) {
                        valA = parseFloat(valA);
                        valB = parseFloat(valB);
                    } else {
                        valA = String(valA).toUpperCase();
                        valB = String(valB).toUpperCase();
                    }

                    if (valA < valB) {
                        return this.bool_isSort ? 1 : -1;
                    } else if (valA > valB) {
                        return this.bool_isSort ? -1 : 1;
                    } else {
                        return 0;
                    }
                });

                let tempCatIndexList = {};
                for (var i = 0; i < tempCatList.length; i++) {
                    if (tempCatIndexList[tempCatList[i]['AGI']] == undefined) {
                        tempCatIndexList[tempCatList[i]['AGI']] = {};
                    }

                    tempCatIndexList[tempCatList[i]['AGI']][tempCatList[i]['CC'] + "#" + tempCatList[i]['OTPCost']] = i;
                }

                const resultList = list.slice().sort((a, b) => {
                    let valA, valB;
                    valA = a[sortField];
                    valB = b[sortField];

                    if (sortField == 'LTS') {
                        valA = Date.parse(valA);
                        valB = Date.parse(valB);
                    }
                    else if (!isNaN(parseFloat(valA)) && !isNaN(parseFloat(valB))) {
                        valA = parseFloat(valA);
                        valB = parseFloat(valB);
                    } else {
                        valA = String(valA).toUpperCase();
                        valB = String(valB).toUpperCase();
                    }

                    if (tempCatIndexList[a['AGI']][a['CC'] + "#" + a['OTPCost']] < tempCatIndexList[b['AGI']][b['CC'] + "#" + b['OTPCost']]) {
                        return -1;
                    }
                    else if (tempCatIndexList[a['AGI']][a['CC'] + "#" + a['OTPCost']] > tempCatIndexList[b['AGI']][b['CC'] + "#" + b['OTPCost']]) {
                        return 1;

                    } else if (a['GN'] == '' && b['GN']) {
                        return 1;
                    }
                    else if (b['GN'] == '' && a['GN']) {
                        return -1;
                    }
                    else if (valA < valB) {
                        return this.bool_isSort ? 1 : -1;
                    } else if (valA > valB) {
                        return this.bool_isSort ? -1 : 1;
                    } else {
                        return 0;
                    }
                });

                let prevCat = '';
                let currentRowNumber = 0, subRowNumber = 0;
                for (var i = 0; i < resultList.length; i++) {
                    if (prevCat != resultList[i]['AGI'] + '|' + resultList[i]['CC'] + '|' + resultList[i]['OTPCost']) {
                        currentRowNumber++;
                        subRowNumber = 0;
                        prevCat = resultList[i]['AGI'] + '|' + resultList[i]['CC'] + '|' + resultList[i]['OTPCost'];
                    }
                    else {
                        subRowNumber++;
                    }

                    if (subRowNumber == 0) {
                        resultList[i]['RN'] = currentRowNumber;
                    }
                    else {
                        resultList[i]['RN'] = currentRowNumber + '.' + subRowNumber;
                    }
                }

                return resultList;
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showActiveMenu = 'R.OTPR';
            if (this.checkModuleIndex('OTPR', 'R', constAccessType.view, '', -1) == '8.5.8') {
                this.$parent.showSubSubMenu = 'RS5';
            } else if (this.checkModuleIndex('OTPR', 'R', constAccessType.view, '', -1) == '7.1.13') {
                this.$parent.showSubSubMenu = 'RS2';
            }

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.hide = this.getUserInfo.SBSA;
            
            this.getCountryList();
        },
        watch: {
            getLanguage() {
                this.getReportList();
            },
            bool_isOTP() {
                if (!this.bool_isOTP && this.bool_CVOTP) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/OTPReport`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                if (!that.repoerIsCrypto) {
                                    that.removeDefaultColumn('BCBA')
                                    that.removeDefaultColumn('BCWLA')
                                    that.removeColumn('BCBA')
                                    that.removeColumn('BCWLA')
                                }
                                if (that.getUserInfo.AT >= 1) {
                                    that.removeDefaultColumn('SAWL')
                                    that.removeDefaultColumn('PSMC')
                                    that.removeColumn('SAWL')
                                    that.removeColumn('PSMC')
                                }
                                if (that.getUserInfo.AT >= 2) {
                                    that.removeDefaultColumn('MAWL')
                                    that.removeDefaultColumn('PMAC')
                                    that.removeColumn('MAWL')
                                    that.removeColumn('PMAC')
                                }
                                if (that.getUserInfo.AT >= 3) {
                                    that.removeDefaultColumn('AWL')
                                    that.removeDefaultColumn('PAC')
                                    that.removeColumn('AWL')
                                    that.removeColumn('PAC')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/OTPReport/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/OTPReport.vue